<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs">
		<app-loader [showLoader]=showLoad></app-loader>
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom">
			<div class="o-stack__cell">
				<h5 class="card-title">{{sectiontitle}}</h5>
				<span class="datatable-icon" *ngIf="!isPlatform">
					<a class="datatable_download_icon" href="javascript:void(0)" (click)="downloadCSV($event)" target="_blank">
						<i _ngcontent-c15="" aria-hidden="true" class="fa fa-download"></i>
					</a>
				</span>
			</div>
			<div class="toggle-button">
					<p>
					<strong>Platforms</strong>
					</p>
					<label class="switch">
						<input type="checkbox" (change)="toggleMode()">
						<span class="slider round"></span>
			  		</label>
			  		<p>
					<strong>Networks</strong>
					</p>
			</div>
		</div>
		<div class="analytics-portlet-content">
			<ngx-datatable class="material" [columns]="dataTableObj.columns" [rows]="isPlatform?newTableDataPlatform.data:newTableDataNetwork.data" [scrollbarV]="true" [sortType]="'single'"
						   [cssClasses]="cssClasses" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="0" [rowHeight]="55" [reorderable]="reorderable">
				<ngx-datatable-column name={{column.name}} prop="{{column.columnKey}}" class="{{column.cellClass}} ctv-column-name"
									  *ngFor="let column of dataTableObj.columns; let i=index;" [sortable]="true">
					<ngx-datatable-column name="{{column.name}}" prop="{{column.prop}}" [resizeable]="false" [sortable]="true"
										  [cellClass]="column.cellClass" [headerClass]="column.headerClass" [comparator]="column.comparator">
						<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
							<span *ngIf="column.name === 'Platform' || column.name === 'Network' else nonPlatform">
								<span (click)="customSort('name')" class="ctv-cursor" *ngIf="!column.columnHasTooltip; else elseBlock">
									{{column.name}}
								</span>
							</span>
							<ng-template #nonPlatform>
								<span (click)="customSort(colHeader.name)" class="ctv-cursor" *ngIf="!column.columnHasTooltip; else elseBlock">
									{{column.name}}
								</span>
							</ng-template>
							<ng-template #elseBlock>
								<span class="ctv-cursor">
									<span *ngIf="column.name === 'Platform' || column.name === 'Network' else nonPlatformElse">
										<span (click)="customSort('name')" appTooltip *ngIf="!column.columnHasTooltip; else elseBlock">
											{{colHeader.name}}
										</span>
									</span>
									<ng-template #nonPlatformElse>
										<span (click)="customSort(colHeader.name)" appTooltip *ngIf="!column.columnHasTooltip; else elseBlock">
											{{colHeader.name}}
										</span>
									</ng-template>
								</span>
							</ng-template>
						</ng-template>
					</ngx-datatable-column>
					<ng-template ngx-datatable-cell-template let-value="value" let-rowIndex="rowIndex" let-row="row">
						<div class="ctv-performance-row">
							<span *ngIf="column.name === 'Platform' || column.name === 'Network'">
								<div class="network-logo" [ngStyle]="{'background-image': 'url(' + row['logo_path'] + ')'}"></div>
								<div class="network-name" *ngIf="column.name === 'Platform'||column.name === 'Network'">{{row['name']}}</div>
							</span>
							{{row[column.prop]}}
							<div class="progressbar" *ngIf="column.hasProgressBar && row[column.prop] !== '--'">
								<div class="bar primary-color-bg" [ngStyle]="getPercentage(row, column.prop)"></div>
							</div>
						</div>
					</ng-template>
				</ngx-datatable-column>
			</ngx-datatable>
		</div>
	</div>